/**
 * External dependencies
 */
import React from 'react';
import classNames from 'classnames';

/**
 * Style dependencies
 */

const NavTabs = (props) => {
    return (
        <div className={classNames('section-nav-group', props.className)}>
            <div className={classNames('section-nav-tabs')}>
                <ul className='section-nav-tabs__list' role='menu'>
                    {props.children}
                </ul>
            </div>
        </div>
    );
};

export default NavTabs;
